import React, { useEffect, useState } from 'react'
import { Modal, Form, Button } from 'react-bootstrap'
import useToken from '../App/useToken'
import axios from 'axios'

export default function MergeFlightsToStandPopup({show, setShow, stand}) {
  const { token } = useToken()
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [message, setMessage] = useState('')
  const [warningMessage, setWarningMessage] = useState('')
  const [mergeData, setMergeData] = useState('')
  const [started, setStarted] = useState(false)
  const name = stand && stand?.name ? stand?.name : stand?.alias ? stand?.alias : ''
  const mergeFlights = async () => {
    setStarted(true)
    var config = {
      method: "post",
      url: "api/merge_stand_data",
      data: {
        'token': token,
        'AID': stand.AID,
        'fromDate': fromDate === "" ? null : new Date(fromDate).toISOString(),
        'toDate': toDate === "" ? null : new Date(toDate).toISOString(),
        'customerId': stand.customerId
      }
    };
    axios(config)
    .then(response => 
     {    
      const data = response.data
      // console.log(response)
      if(data.AID){
        if(mergeData){
          setMessage(data.msg + " Starting to merge data, may take a few minutes")
        } else {
          setMessage(data.msg)
        }
      } else {
        setWarningMessage(data.msg)
      }
    })
    .catch(error => {
      // console.log("error", error)
    })
  } 

  const reset = () =>{
    setFromDate('')    
    setToDate('')
    setMessage('')
    setWarningMessage('')
    setMergeData('')
    setStarted(false)
  }
  useEffect(()=>{
    reset()
  }, [])
  return (
    <Modal
      show={show}
      onHide={() => {
        reset()
        setShow(false)
      }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div style={{backgroundColor: "#212529", color: "#ffffff"}}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Merge linked flights to stand {name} within the selected dates.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div>
        Choose between wich dates the flights to merge took place. 
      <Form style={{display:'flex', marginBottom: '10px'}}>
            
            <Form.Group controlId="formFromDate" style={{ marginTop: "10px" }}>
              <Form.Label>From Date</Form.Label>
              <Form.Control
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formToDate" style={{ marginTop: "10px" }}>
              <Form.Label>To Date</Form.Label>
              <Form.Control
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Form.Group>
          </Form>
          </div>
              <div style={{ color: "orange", marginTop: "10px" }}>
                Important. Merging flight data within the same dates will overwrite the old.
              </div>
      </Modal.Body>
      <Modal.Footer>
        {message && <div style={{ marginTop: "10px" }}>
            {message}
          </div>}
          {warningMessage && <div style={{ color: "orange", marginTop: "10px" }}>
               {warningMessage}
          </div>}
        {!message && <Button disabled={started} onClick={() => mergeFlights()}>{'Merge'}</Button>}
        <Button 
          onClick={() => {
            reset()
            setShow(false)
          }}>Close</Button>
      </Modal.Footer>
      </div>
    </Modal>
  );
}

